var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.post
    ? _c(
        "div",
        [
          _vm.post
            ? _c("page-title-header", {
                staticClass: "scroll-effect",
                class: { "is-active": _vm.isLoaded },
                attrs: { category: _vm.post.category },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "left-col-container" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-sm-9 left-col-text",
                      attrs: { id: "article" },
                    },
                    [
                      _vm.post
                        ? _c(
                            "div",
                            {
                              staticClass: "scroll-effect",
                              class: { "is-active": _vm.isLoaded },
                            },
                            [
                              _c("h1", [_vm._v(_vm._s(_vm.post.title))]),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "article_body",
                                domProps: {
                                  innerHTML: _vm._s(_vm.post.bodyHtml),
                                },
                              }),
                              _vm._v(" "),
                              _vm.post.links
                                ? _c(
                                    "ul",
                                    { staticClass: "links" },
                                    _vm._l(_vm.post.links, function (link) {
                                      return _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: link.url,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v(_vm._s(link.label))]
                                        ),
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _vm.post.tags
                                ? _c("div", [
                                    _vm._m(0),
                                    _vm._v(" "),
                                    _c(
                                      "ul",
                                      { staticClass: "tags" },
                                      _vm._l(_vm.post.tags, function (tag) {
                                        return _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: `/posts/?tag=${tag.label}`,
                                              },
                                            },
                                            [_vm._v(_vm._s(tag.label))]
                                          ),
                                        ])
                                      }),
                                      0
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.post
                    ? _c("side-menu", {
                        staticClass: "js-scroll-effect scroll-effect",
                        attrs: {
                          category: _vm.post.category,
                          "data-start-pos": "200",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("span", { staticClass: "glyphicon glyphicon-tags" }),
      _vm._v("タグ"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }